import CoreAPIClientError from "@/api/core/CoreAPIClientError";
import { useQuery } from "@tanstack/react-query";
import { FindMspGrantsQueryResult } from "@ternary/api-lib/core/queries/FindMspGrantsQuery";
import { useCoreRequestSender } from "../../../api/CoreRequestSenderProvider";
import { UseQueryOptions, UseQueryResult } from "../../../lib/react-query";
import { queryKeys } from "./queryKeys";

const FAILED_LOADING_GRANTS = "FAILED_LOADING_GRANTS";

type GrantEntity = FindMspGrantsQueryResult["grants"][0];

export function useGetMspGrantsByParentTenantID(
  parentTenantID: string,
  options?: UseQueryOptions<GrantEntity[], CoreAPIClientError>
): UseQueryResult<GrantEntity[], CoreAPIClientError> {
  const sender = useCoreRequestSender();

  return useQuery({
    queryKey: queryKeys.mspGrants(parentTenantID),
    queryFn: async () => {
      try {
        const result = (await sender.send(
          `/grants/msp?parentTenantID=${parentTenantID}`
        )) as FindMspGrantsQueryResult;

        return result.grants;
      } catch (error) {
        console.error(error);

        throw new CoreAPIClientError(FAILED_LOADING_GRANTS);
      }
    },
    ...options,
  });
}
